import axios from '../providers/axios';
import apiFiles from '../providers/apiFiles';

export const getDriverTypes = () => axios.get('/types/drivers');
export const getCnhTypes = () => axios.get('/types/cnh');
export const listDrivers = params => axios.get('/drivers', { params });
export const findDriver = id => axios.get(`/drivers/${id}`);
export const driverByCPF = cpf => axios.get(`/drivers/cpf/${cpf}`);
export const createDriver = data => axios.post('/drivers', data);
export const validateDriver = driver => axios.get(`drivers/${driver.id}/complete`);
export const queryDrivers = q => axios.get('/drivers', { params: { q } });
export const validityCnh = cpf => axios.get(`/drivers/validitybycnh/${cpf}`);
export const validityValues = () => axios.get('/drivers/company/validitybycnh');
export const requiredFreight = data => axios.get('/freight/required', data);
export const getDriverCertificates = () => axios.get('/query/custom/certificate-types/driver');
export const saveCertificate = data => apiFiles.post('/doc', data);

export const fetchQueryFreight = (page, query) =>
  axios.get(`freight?limit=10&page=${page}&q=${query}`);

export const patchDriver = (
  id = null,
  {phones, ...data},
  rgFile = null,
  cnhFile = null,
  consentFormFile = null,
  freightId = null,
  uploadedCertificates = []
) => {
  const newData = new FormData();

  if(freightId){
    newData.append('freightId', freightId);
  }

  if(rgFile){
    newData.append('rgFile', rgFile);
    newData.append('hasRgFile', true);
  }

  if(cnhFile){
    newData.append('cnhFile', cnhFile);
    newData.append('hasCnhFile', true);
  }

  if(consentFormFile){
    newData.append('consentFormFile', consentFormFile);
  }

  Object.entries(data)
    // eslint-disable-next-line no-unused-vars
    .filter(([_key, value]) => {
      if(_key.includes('validity')){
        return true;
      }

      return value !== undefined && value !== null;
    })
    .map(([key, value]) => newData.append(key, value));

  newData.append('phones', JSON.stringify(phones));

  if (uploadedCertificates.length > 0) {
    newData.append('certificates', JSON.stringify(uploadedCertificates));
  }

  return id
    ? axios.patch(`/drivers/${id}`, newData)
    : axios.post('/drivers', newData);
};

export function uploadCNH(driverId, file) {
  const data = new FormData();

  data.append('cnh', file);

  return axios.put(`drivers/${driverId}/cnh`, data);
}

export function uploadRG(driverId, file) {
  const data = new FormData();

  data.append('rg', file);

  return axios.put(`drivers/${driverId}/rg`, data);
}

export function driverCNHFileBlob(driverId) {
  return axios
    .get(
      `/drivers/${driverId}/cnh`,
      { responseType: 'blob' }
    );
}

export function driverRGFileBlob(driverId) {
  return axios
    .get(
      `/drivers/${driverId}/rg`,
      { responseType: 'blob' }
    );
}

export function driverConsentFormFileBlob(driverId) {
  return axios
    .get(
      `/drivers/${driverId}/consentForm`,
      { responseType: 'blob' }
    );
}

export const driverTypeFromHistory = {
  FUN: 'Funcionário',
  AUT: 'Autônomo (Terceiro)',
  AGR: 'Agregado',
  FNM: 'Funcionário não motorista',
  OUT: 'Outros',
};
